import { handleActions } from "redux-actions";

export default handleActions(
  {
    MODAL_OPEN: ({ modals }, { modal }) => ({
      modals: [...modals, modal],
    }),
    MODAL_CLOSE: ({ modals }, { modal }) => ({
      modals: modals.filter((m) => m.type !== modal.type),
    }),
  },
  {},
  { namespace: "_" }
);
